module.exports = __webpack_public_path__ + "c887b90b3bab5f09248cffac96f146b2.png";